import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserPreferenceContext } from '@contexts/user-preference-context';
import { useGlobalState } from '@providers/global-context-provider';
import { useSFConnectionState } from '@contexts/sf-connection-context';

const useConnectionSyncSuccessful = () => {
  const navigate = useNavigate();
  const { userPreference } = useContext(UserPreferenceContext);
  const { handleReloadPrimaryMenu } = useGlobalState();

  const { handleUpdateOverlayMode, handleReload, handleRefetchConnectionList } =
    useSFConnectionState();

  const handleClose = useCallback(() => {
    handleUpdateOverlayMode('none');
    handleReload();
    handleReloadPrimaryMenu();
    handleRefetchConnectionList(true);
  }, [handleUpdateOverlayMode, handleReload, handleReloadPrimaryMenu]);

  const handleNavigateToTestCases = useCallback(() => {
    handleUpdateOverlayMode('none');
    navigate(
      `/td/${userPreference?.preference?.projectPreference?.selectedVersionId}/cases`,
    );
    handleReloadPrimaryMenu();
  }, [
    handleUpdateOverlayMode,
    handleReloadPrimaryMenu,
    navigate,
    userPreference?.preference?.projectPreference?.selectedVersionId,
  ]);

  const handleCloseOnPartiallySuccess = useCallback(() => {
    handleUpdateOverlayMode('none');
    handleRefetchConnectionList(true);
  }, [handleUpdateOverlayMode]);

  return {
    handleClose,
    handleNavigateToTestCases,
    handleCloseOnPartiallySuccess,
  };
};

export { useConnectionSyncSuccessful };
